var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Blocks',{attrs:{"blocks":_vm.config,"customComponents":_vm.customComponents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }